module.exports = __webpack_public_path__ + "img/bill_white.3d98b5ae.svg";